import React from 'react'

const FiveMetodePembayaranIndividu = (props) => {
    // console.log(props.dataInputRegistration)
    return (
        <>
            <div className='row' style={{ marginLeft: '5px', marginTop: '2%' }}>
                <h5 style={{ color: '#26D07C', marginBottom: '3%', fontSize: '16px', fontWeight: '700' }}>Metode Pembayaran</h5>
                <div className='col-lg-12'>
                    <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Metode Pembayaran</label>
                    <p style={{ color: '#0C86D9', fontSize: props.size.width < 500 ? '12px' : '18px', fontWeight: '500' }}>Individual</p>
                    <hr className='mt-0'></hr>
                </div>
                <div className='row'>
                    <div className='col-lg-6'>
                        <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Sapaan / Salutation</label>
                        <p style={{ color: '#191919', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{props.dataInputRegistration.salutationIndividu}</p>
                    </div>
                    <div className='col-lg-6'>
                        <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Nama Lengkap</label>
                        <p style={{ color: '#191919', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{props.dataInputRegistration.namaDepanPic} {props.dataInputRegistration.namaBelakangPic}</p>
                    </div>
                    <hr className='mt-3'></hr>
                </div>
                <div className='row'>
                    <div className='col-lg-6'>
                        <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Kartu Identitas Peserta</label>
                        <p style={{ color: '#191919', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{props.dataInputRegistration.kartuIdentitasIndividu}</p>
                    </div>
                    <div className='col-lg-6'>
                        <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Nomor Identitas</label>
                        <p style={{ color: '#191919', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{props.dataInputRegistration.nikIndividu}</p>
                    </div>
                    <hr className='mt-0'></hr>
                </div>
                <div className='col-lg-12'>
                    <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Pekerjaan</label>
                    <p style={{ color: '#191919', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{props.dataInputRegistration.pekerjaanIndividu}</p>
                    <hr className='mt-0'></hr>
                </div>
                <div className='row'>
                    <div className='col-lg-6'>
                        <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Nama Perusahaan</label>
                        <p style={{ color: '#191919', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{props.dataInputRegistration.namaPerusahaanIndividu}</p>
                    </div>
                    <div className='col-lg-6'>
                        <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Jabatan</label>
                        <p style={{ color: '#191919', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{props.dataInputRegistration.jabatanIndividu}</p>
                    </div>
                    <hr className='mt-0'></hr>
                </div>
                <div className='col-lg-12'>
                    <label className="form-label" style={{ color: '#5E6278', fontSize: props.size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Alamat</label>
                    <p style={{ color: '#191919', fontSize: props.size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{props.dataInputRegistration.patokanIndividu} {props.dataInputRegistration.kecamatanIndividu} {props.dataInputRegistration.kotaIndividu} {props.dataInputRegistration.provinsiIndividu} {props.dataInputRegistration.kodeposIndividu}</p>
                    <hr className='mt-0'></hr>
                </div>

            </div>
        </>
    )
}

export default FiveMetodePembayaranIndividu
